import React from 'react'
import type { Document } from '@contentful/rich-text-types'
import type { ComposeComponentRichTextColouredBackgroundFragment } from '../../../.graphql/generated-types'
import { ContentfulRichText } from '../../components/ContentfulRichText'

export interface RichTextColouredBackgroundProps {
  data: ComposeComponentRichTextColouredBackgroundFragment
}

export function RichTextColouredBackground({
  data,
}: RichTextColouredBackgroundProps) {
  if (data.text?.json) {
    let backgroundColourClassName = 'bg-[#E8F6FC]'
    if (data.backgroundTheme === 'Blue') {
      backgroundColourClassName = 'bg-[#E8F6FC]'
    } else if (data.backgroundTheme === 'Grey') {
      backgroundColourClassName = 'bg-[#f8f8f8]'
    }

    return (
      <div
        className={`flex flex-col space-y-4 rounded p-6 md:flex-row md:space-x-4 md:space-y-0 ${backgroundColourClassName}`}
      >
        <div className="flex-grow">
          <ContentfulRichText
            document={data.text.json as Document}
            entries={data.text.links.entries}
          />
        </div>
        <style global jsx>{`
          h2 {
            margin-bottom: 1rem;
          }
        `}</style>
      </div>
    )
  }
  return null
}
